import { A01, A01Output } from 'api/U015';
import { useAuth } from 'hooks/useAuth';
import { useEffect, useState } from 'react';

export function useGetConsentHooks(
  userId: string,
  lang: string
): [A01Output | undefined, boolean, Error | null] {
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [consent, setConsent] = useState<A01Output>();
  const [err, setError] = useState<Error | null>(null);

  const fetchConsent = async (userId: string, lang: string, cancellation: AbortSignal) => {
    return await A01({ user_id: userId, lang }, cancellation);
  };

  useEffect(() => {
    if (!isAuthenticated || !userId) {
      return;
    }

    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      setLoading(true);
      setError(null);
      try {
        const consent = await fetchConsent(userId, lang, cancellation);
        setConsent(consent);
      } catch (err) {
        console.error(err);
        setConsent(undefined);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      // controller.abort()
    };
  }, [isAuthenticated, userId]);

  return [consent, loading, err];
}
